export const vehicleTypeList = [
  {
    value: 'CYCLE',
    name: 'Cycle'
  },
  {
    value: 'TWO_WHEELER',
    name: 'Two Wheeler'
  },
  {
    value: 'THREE_WHEELER',
    name: 'Three Wheeler'
  },
  {
    value: 'FOUR_WHEELER',
    name: 'Four Wheeler'
  },
  {
    value: 'COMMERCIAL_VEHICLE',
    name: 'Commercial Wheeler'
  }
];

const startYear = 2024;
const currentYear = new Date().getFullYear();
export const yearRange = Array.from({ length: currentYear - startYear + 1 }, (_, index) => ({
  value: (startYear + index).toString(),
  name: (startYear + index).toString()
}));

export const monthList = [
  {
    value: '1',
    name: 'January'
  },
  {
    value: '2',
    name: 'February'
  },
  {
    value: '3',
    name: 'March'
  },
  {
    value: '4',
    name: 'April'
  },
  {
    value: '5',
    name: 'May'
  },
  {
    value: '6',
    name: 'June'
  },
  {
    value: '7',
    name: 'July'
  },
  {
    value: '8',
    name: 'August'
  },
  {
    value: '9',
    name: 'September'
  },
  {
    value: '10',
    name: 'October'
  },
  {
    value: '11',
    name: 'November'
  },
  {
    value: '12',
    name: 'December'
  }
];

export const vehicleType = [
  { name: 'Cycles', value: 'CYCLE' },
  { name: 'Two Wheelers', value: 'TWO_WHEELER' },
  { name: 'Three Wheelers', value: 'THREE_WHEELER' },
  { name: 'Cars', value: 'FOUR_WHEELER' },
  { name: 'Commercial Vehicle', value: 'COMMERCIAL_VEHICLE' }
];

export const classifyBasedOnVehicleType = [
  { id: '1', label: 'Scooter', value: 'Scooter', type: 'TWO_WHEELER' },
  { id: '3', label: 'Bike', value: 'Bike', type: 'TWO_WHEELER' },
  { id: '2', label: 'Cruiser', value: 'Cruiser', type: 'TWO_WHEELER' },
  { id: '4', label: 'SuperBikes', value: 'SuperBikes', type: 'TWO_WHEELER' },
  { id: '5', label: 'Passenger', value: 'Passenger', type: 'THREE_WHEELER' },
  { id: '6', label: 'Good Vehicles', value: 'Good Vehicles', type: 'THREE_WHEELER' },
  { id: '7', label: 'Hatchback', value: 'Hatchback', type: 'FOUR_WHEELER' },
  { id: '8', label: 'Sedan', value: 'Sedan', type: 'FOUR_WHEELER' },
  { id: '9', label: 'SUV', value: 'SUV', type: 'FOUR_WHEELER' },
  { id: '10', label: 'MUV', value: 'MUV', type: 'FOUR_WHEELER' },
  { id: '11', label: 'Van', value: 'Van', type: 'COMMERCIAL_VEHICLE' },
  { id: '12', label: 'Bus', value: 'Bus', type: 'COMMERCIAL_VEHICLE' },
  { id: '13', label: 'LCV', value: 'LCV', type: 'COMMERCIAL_VEHICLE' },
  { id: '14', label: 'MCV', value: 'MCV', type: 'COMMERCIAL_VEHICLE' },
  { id: '15', label: 'HCV', value: 'HCV', type: 'COMMERCIAL_VEHICLE' }
];

export const vehicleGearType = [
  { id: '1', value: 'MANUAL', label: 'Manual Transmission', shortName: 'MT' },
  { id: '2', value: 'AUTOMATIC', label: 'Automatic Transmission', shortName: 'AT' }
];

export const registrationTypeSellModule = [
  {
    id: '1',
    _id: 'personal_vehicle',
    label: 'Personal Vehicle       ( White Board )',
    value: 'nonTransportVehicle',
    icon: 'https://serviceplug-prod.s3.ap-south-1.amazonaws.com/389/1712839334389/perVehicle.jpeg'
  },
  {
    id: '2',
    _id: 'transport_vehicle',
    label: 'Transport Vehicle      ( Yellow Board )',
    value: 'transportVehicle',
    icon: 'https://serviceplug-prod.s3.ap-south-1.amazonaws.com/369/1712839535369/traVehicle.jpeg'
  },
  {
    id: '3',
    _id: 'ev_personal_vehicle',
    label: 'EV Personal Vehicle  ( Green Board )',
    value: 'evPersonalVehicle',
    icon: 'https://serviceplug-prod.s3.ap-south-1.amazonaws.com/578/1712839572578/eleVehicle.jpeg'
  },
  {
    id: '4',
    _id: 'ev_transport_vehicle',
    label: 'EV Transport Vehicle ( Green-Yellow Board )',
    value: 'evTransportVehicle',
    icon: 'https://serviceplug-prod.s3.ap-south-1.amazonaws.com/997/1712839601997/evePubVehicle.jpeg'
  },
  {
    id: '5',
    _id: 'rental_vehicle',
    label: 'Rental Vehicle            ( Black Board )',
    value: 'rentalVehicle',
    icon: 'https://serviceplug-prod.s3.ap-south-1.amazonaws.com/369/1712839661369/renVehicle.jpeg'
  }
];

export const fitnessCertificate = [
  { id: '1', value: true, label: 'Yes' },
  { id: '2', value: false, label: 'No' }
];

export const vehicleCheckList = [
  {
    value: 'CYCLE',
    name: 'Cycles'
  },
  {
    value: 'TWO_WHEELER',
    name: 'Two Wheelers'
  },
  {
    value: 'THREE_WHEELER',
    name: 'Three Wheelers'
  },
  {
    value: 'FOUR_WHEELER',
    name: 'Cars'
  },
  {
    value: 'COMMERCIAL_VEHICLE',
    name: 'Commercial Vehilce'
  }
];

export const userTypeList = [
  { id: '1', value: 'ALL', label: 'ALL' },
  { id: '2', value: 'PARTNER', label: 'PARTNER' },
  { id: '3', value: 'CUSTOMER', label: 'CUSTOMER' }
];
